module.exports = __webpack_public_path__ + "img/m_contents_biz@2x.9bc439d1.png";